import React, {Component} from 'react';

class MiniLoader extends Component {
    render () {
        return (
            <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        )
    }
}

export default MiniLoader;


// WEBPACK FOOTER //
// ./src/components/MiniLoader.js